export default "__VITE_ASSET__ZDtzAkfl__"